/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

export const candidateFileExtensions = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png'] as const

export type CandidateFileExtensions = typeof candidateFileExtensions
